import {Record, type RecordOf} from 'immutable';

export type GettingStartedStatusStateProps = {
  cmsCollectionsExist: boolean;
  cmsCollectionsCurrent: boolean;
  checkoutEnabled: boolean;
  hasAddedCart: boolean;
  hasBusinessAddress: boolean;
  hasReviewedCurrencySettings: boolean;
  hasCheckedTaxSettings: boolean;
  hasCorrectHostingPlan: boolean;
  hasPaymentProcessor: boolean;
  hasProducts: boolean;
  hasShippingMethods: boolean;
  hasSSLEnabled: boolean;
  hasVisitedCategoryPage: boolean;
  hasVisitedCheckoutPage: boolean;
  hasVisitedProductPage: boolean;
  hasSeenGettingStarted: boolean;
  hasCheckedEmailSettings: boolean;
};

export type GettingStartedStatusStateShape =
  RecordOf<GettingStartedStatusStateProps>;

// @ts-expect-error - TS2322 - Type 'Factory<{ cmsCollectionsExist: true; cmsCollectionsCurrent: true; checkoutEnabled: false; hasAddedCart: false; hasBusinessAddress: false; hasReviewedCurrencySettings: false; hasCheckedTaxSettings: false; ... 9 more ...; hasCheckedEmailSettings: false; }>' is not assignable to type 'Factory<GettingStartedStatusStateProps>'.
export const CommerceGettingStartedStatusStateRecord: Record.Factory<GettingStartedStatusStateProps> =
  Record(
    {
      cmsCollectionsExist: true,
      cmsCollectionsCurrent: true,
      checkoutEnabled: false,
      hasAddedCart: false,
      hasBusinessAddress: false,
      hasReviewedCurrencySettings: false,
      hasCheckedTaxSettings: false,
      hasCorrectHostingPlan: false,
      hasPaymentProcessor: true,
      hasProducts: false,
      hasShippingMethods: false,
      hasSSLEnabled: false,
      hasVisitedCategoryPage: false,
      hasVisitedCheckoutPage: false,
      hasVisitedProductPage: false,
      hasSeenGettingStarted: false,
      hasCheckedEmailSettings: false,
    },
    'CommerceGettingStartedStatusStateRecord'
  );
